export const getElement = (root) => (query) => root.querySelector(query);
export const getElements = (root) => (query) => root.querySelectorAll(query);
export const getElementRectValue = (element, item) => {
    const rect = element.getClientRects().item(0);
    return rect.toJSON()[item];
};
export const getNavigationHeaderHeight = () => { var _a; return (_a = document.querySelector('#header-navigation')) === null || _a === void 0 ? void 0 : _a.offsetHeight; };
export const isSingleRoute = (pathname = location.pathname) => Boolean(pathname.replace(/\D/g, ''));
export const removeLeftZeros = (number) => {
    if (Number(number) === 0 || !Number(number))
        return '0';
    const firstNonZeroNumber = number.match(/[1-9]/);
    if (number.length > 1 && number[0] === '0') {
        return number.substring(number.indexOf(firstNonZeroNumber[0]));
    }
    return number;
};
export const isSolidType = (type) => type === 'solid';
export const isOutlineType = (type) => type === 'outline';
export const isLinkType = (type) => type === 'link';
export const isPercent = (value) => String(value).includes('%');
export const registerElement = (tagName, component) => {
    !customElements.get(tagName) && customElements.define(tagName, component);
};
export const isValidString = (value) => !!value;
import { NOT_DEFINED } from '../constants/general';
export const getFormattedValueOrNotDefined = (value, format) => {
    return value ? format(parseFloat(value)) : NOT_DEFINED;
};
export const getColorVariableName = (color, tone = 'dark') => {
    if (color.startsWith('black'))
        return `--${color}`;
    return `--${color}-color-${tone}`;
};
export const getIdParamFromUrl = () => {
    const path = location.pathname;
    return parseInt(path.replace(/\D/g, ''));
};
export const getAssetsBaseURL = () => {
    const { hostname } = location;
    if (/positronic-frontend|devlocal|localhost/g.test(hostname)) {
        const { port, protocol } = location;
        return `${protocol.replace(':', '')}://${hostname}${port ? `:${port}` : ''}/assets`;
    }
    return 'https://main.app.smarttbot.com/assets';
};
export function getQueryParam(param) {
    const query = new URLSearchParams(location.search);
    if (Array.isArray(param)) {
        const values = [];
        param.forEach((keyParam) => {
            values.push(query.get(keyParam));
        });
        return values;
    }
    return query.get(param);
}
export const isNullOrUndefined = (value) => value == null;
export const checkIsPublicRoute = (url = location.pathname) => /\/public/g.test(url);
export const checkIsPublicStore = (url = location.pathname) => /\/public\/store/g.test(url);
export const getEvent = (event) => new Event(event, { bubbles: true, composed: true });
export const isGreaterThanOrEqual = (firstValue, secondValue) => !!firstValue && !!secondValue && firstValue >= secondValue;
export const isSmallerThanOrEqual = (firstValue, secondValue) => !!firstValue && !!secondValue && firstValue <= secondValue;
export function isSameDate(date1, date2) {
    return date1.setHours(0, 0, 0, 0) === date2.setHours(0, 0, 0, 0);
}
export function isEmpty(value) {
    if (value && typeof value === 'object') {
        if (Array.isArray(value))
            return !value.length;
        return !Object.keys(value).length;
    }
    return value !== 0 && !value;
}
export function isStorePath() {
    return /store/g.test(location.pathname);
}
//# sourceMappingURL=general.js.map